import { useMsal } from '@azure/msal-react'
import { BasicButton } from '@orobix/orobix-fe-components'
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import singInLogoEn from '../../assets/sign-in-with-microsoft-light-en.svg'
import singInLogoIt from '../../assets/sign-in-with-microsoft-light-it.svg'
import { getEnvs } from '../../utils/env'
import { locations } from '../../utils/locations'
import useStyles from './SignInRoot.styles'

const { backendAppClientId } = getEnvs()

const loginRequest = {
  scopes: [`${backendAppClientId}/.default`],
}

const SignInRoot = (): JSX.Element => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { instance } = useMsal()
  const history = useHistory()

  return (
    <>
      <p>
        {t(
          'To sign in into this application you need a valid Microsoft work account with the right permissions.'
        )}
      </p>
      <BasicButton
        buttonType="button"
        onClick={() =>
          instance
            .loginPopup(loginRequest)
            .then((loginResponse) => {
              history.push(locations.products)
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error))
        }
        title={t('Sing in with Microsoft')}
      >
        <img
          src={i18n.language === 'it' ? singInLogoIt : singInLogoEn}
          alt=""
          className={classes.block}
        />
      </BasicButton>
    </>
  )
}

export default SignInRoot
